import { fetchWrapper, hcUrl, handleResponse, buildOpts } from 'services/RequestService/helpers';

const getRestartCampaign = async ({ id }) => {
  const url = id ? `/reactivate?restart_campaign_id=${id}` : '/reactivate';
  const response = await fetchWrapper(hcUrl(url), buildOpts());
  return handleResponse(response);
};

export { getRestartCampaign };
